import { Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { apiEndpoints } from "./ApiConfig";
import axiosInterceptor from "./axiosInterceptors";
import { isAuthenticatedStatusResponse } from "./authStatus";
import PageLoader from "../Components/Loader/PageLoader";

const PrivateRoute = () => {
  const [auth, setAuth] = useState(null);
  const [userData, setuserData] = useState();

  useEffect(() => {
    axiosInterceptor
      .get(apiEndpoints?.verifyTokenApi, { withCredentials: true })
      .then((res) => {
        if (isAuthenticatedStatusResponse(res)) {
          setAuth(true);
          setuserData(res);
        } else {
          setAuth(false);
        }
      })
      .catch(() => {
        setAuth(false);
      });
  }, []);

  if (auth === null) {
    return <PageLoader label="Loading" />;
  }

  return auth ? <Outlet context={{ userData }} /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
